// Реестр web-шитов: ключ ScreensList → ленивый компонент.
// Полноэкранные form sheets сюда НЕ добавляются (см. router/routes-sheets.ts) —
// только маленькие попап-шторки поверх экрана.

import { ScreensList, type SheetKey } from '@shared-core/navigation'
import { type LazySheetEntry, lazySheet } from '@web/sheets/lazy-sheet'
import type { ComponentType } from 'react'

export const SHEET_REGISTRY: Record<string, LazySheetEntry> = {}
SHEET_REGISTRY[ScreensList.FORM_SHEET_WALLET_PAY_GUIDE] = lazySheet(
  () => import('@shared-ui/form-sheets/wallet-pay-guide'),
  'FormSheetWalletPayGuide',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_LANGUAGE] = lazySheet(
  () => import('@shared-ui/form-sheets/language'),
  'FormSheetLanguage',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_FAQ_ANSWER] = lazySheet(
  () => import('@shared-ui/form-sheets/faq-answer'),
  'FormSheetFaqAnswer',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_EMAIL_PROMPT] = lazySheet(
  () => import('@shared-ui/form-sheets/email-prompt'),
  'FormSheetEmailPrompt',
)

SHEET_REGISTRY[ScreensList.FORM_SHEET_SELECT_CARD] = lazySheet(
  () => import('@shared-ui/form-sheets/select-card'),
  'FormSheetSelectCard',
)

// Все popup/form-sheet из мобильного роутера должны открываться поверх текущего экрана.
SHEET_REGISTRY[ScreensList.CARD_INFO] = lazySheet(() => import('@mobile/screens/card-info'), 'ScreenCardInfo')
SHEET_REGISTRY[ScreensList.FORM_SHEET_ISSUE_CARD] = lazySheet(
  () => import('@mobile/screens/issue-card-sheet'),
  'ScreenIssueCardSheet',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_CARD_READY] = lazySheet(
  () => import('@mobile/screens/card-ready-sheet'),
  'ScreenCardReadySheet',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_PROFILE] = lazySheet(
  () => import('@mobile/screens/profile-sheet'),
  'ScreenProfileSheet',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_THEME] = lazySheet(
  () => import('@mobile/screens/theme-sheet'),
  'ScreenThemeSheet',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_FAQ] = lazySheet(() => import('@mobile/screens/faq-sheet'), 'ScreenFaqSheet')
SHEET_REGISTRY[ScreensList.FORM_SHEET_BILLING_ADDRESS] = lazySheet(
  () => import('@shared-ui/form-sheets/billing-address'),
  'FormSheetBillingAddress',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_WITHDRAW_BANK] = lazySheet(
  () => import('@mobile/screens/withdraw-bank-sheet'),
  'ScreenWithdrawBankSheet',
)
SHEET_REGISTRY[ScreensList.FORM_SHEET_WITHDRAW_CONFIRM] = lazySheet(
  () => import('@mobile/screens/withdraw-confirm'),
  'ScreenWithdrawConfirm',
)

export function isRegisteredSheetKey(key: string): key is SheetKey & string {
  return key in SHEET_REGISTRY
}

export function registerSheet(key: string, entry: LazySheetEntry): void {
  SHEET_REGISTRY[key] = entry
}

export function sheetScreenComponentFor(key: string): ComponentType | null {
  return SHEET_REGISTRY[key]?.Component ?? null
}

export { lazySheet }
